export default __webpack_public_path__ + "static/media/start-again-icon.e4df5ca7.svg";